import Autocomplete from "@material-ui/core/Autocomplete";
import CircularProgress from "@material-ui/core/CircularProgress";
import TextField from "@material-ui/core/TextField";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Vendor } from "../../../../server/routes/vendor/types";
import useAlerts from "../../hooks/useAlerts";
import { getVendorList } from "../../requests";
import { actionChangeField } from "../../store/invoice/create/actions";
import { FieldVendorFC } from "./types";

let timer: NodeJS.Timeout;
const FieldVendor: FieldVendorFC = ({ saving }) => {
  const dispatch = useDispatch();
  const alerts = useAlerts();
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [options, setOptions] = useState<Vendor[]>([]);
  const [search, setSearch] = useState("");
  const { token, value, error } = useSelector(
    ({
      authToken: { token = "" },
      invoice: {
        create: { invoice, errors },
      },
    }) => ({
      token,
      value: invoice?.vendor ?? null,
      error: errors?.vendor ?? false,
    })
  );

  useEffect(() => {
    setLoading(true);
    if (token.length === 0) {
      return;
    }
    getVendorList(token, 0, 10, { search })
      .then(({ list: vendors }) => {
        setOptions(Object.values(vendors));
        setLoading(false);
      })
      .catch(({ message }: Error) => {
        alerts({ variant: "error", message });
      });
  }, [search, token]);
  const handlerChangeInput = ({
    target: { value },
  }: React.ChangeEvent<HTMLInputElement>) => {
    timer && clearTimeout(timer);
    timer = setTimeout(() => {
      setSearch(value);
    }, 250);
  };

  return (
    <Autocomplete
      open={open}
      onOpen={() => {
        setOpen(true);
      }}
      onClose={() => {
        setOpen(false);
      }}
      value={value}
      onChange={(e, value) => {
        dispatch(actionChangeField({ field: "vendor", value }));
      }}
      isOptionEqualToValue={(option, value) => option.id === value.id}
      getOptionLabel={(option) => option.name}
      options={options}
      noOptionsText={"Не найден ни один поставщик"}
      loading={loading}
      disabled={saving}
      loadingText={"Загрузка списка"}
      renderInput={(params) => (
        <TextField
          {...params}
          error={error}
          placeholder={"Название поставщика"}
          onChange={handlerChangeInput}
          InputProps={{
            ...params.InputProps,
            sx: { paddingRight: "49px" },
            endAdornment: (
              <React.Fragment>
                {loading ? (
                  <CircularProgress
                    color="inherit"
                    size={20}
                    sx={{ marginRight: "20px" }}
                  />
                ) : null}
                {params.InputProps.endAdornment}
              </React.Fragment>
            ),
          }}
        />
      )}
    />
  );
};

export default FieldVendor;
